module.exports = __webpack_public_path__ + "img/img3.7bf25b27.svg";